import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch Survey Status
export const fetchSurveyStatus = createAsyncThunk(
  "surveyStatus/fetchSurveyStatus",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/transaction/panel/SurveyStatus");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Add Survey Status
export const addSurveyStatus = createAsyncThunk(
  "surveyStatus/addSurveyStatus",
  async (newSurveyStatus, { rejectWithValue }) => {
    try {
      const response = await api.post("/transaction/panel/SurveyStatus", newSurveyStatus);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Update Survey Status
export const updateSurveyStatus = createAsyncThunk(
  "surveyStatus/updateSurveyStatus",
  async (surveyStatusData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/transaction/panel/SurveyStatus", surveyStatusData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Survey Status Slice
const surveyStatusSlice = createSlice({
  name: "surveyStatus",
  initialState: {
    surveyStatusList: [],
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Survey Status
      .addCase(fetchSurveyStatus.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchSurveyStatus.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.surveyStatusList = action.payload;
      })
      .addCase(fetchSurveyStatus.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add Survey Status
      .addCase(addSurveyStatus.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addSurveyStatus.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addSurveyStatus.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Update Survey Status
      .addCase(updateSurveyStatus.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateSurveyStatus.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateSurveyStatus.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError } = surveyStatusSlice.actions;

export default surveyStatusSlice.reducer;
